import { useCallback, useEffect } from 'react';

import ProductCard from 'components/common/ProductCard';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import { evRecommendationClick, evRecommendationImpressionWrapper } from 'events/recommendations';
import { trackEvent } from 'helpers/analytics';
import { track } from 'apis/amethyst';

import css from 'styles/components/search/inlineRecosNpc.scss';

/*
  Once `npc` AKA HYDRA_NEW_PRODUCT_CARD is finished you can delete either
  this component or the legacy SearchInlineRecos component.
*/
export const SearchInlineRecosNpc = ({ inlineRecos = {}, heartsInfo, msaImageParams, searchTerm }) => {
  const { title, recos } = inlineRecos;

  const handleInlineRecoClick = useCallback(({ index, styleId, productId }) => {
    trackEvent('TE_SEARCH_INLINE_RECO_CLICK', `styleId:${styleId}productIndex:${index}:searchTerm:${searchTerm}`);
    track(() => ([
      evRecommendationClick, {
        index: index + 1,
        recommendationType: 'PRODUCT_RECOMMENDATION',
        recommendationValue: productId,
        recommendationSource: 'EP13N',
        widgetType: 'SIMILAR_PRODUCT_WIDGET'
      }
    ]));
  }, [searchTerm]);

  useEffect(() => {
    const styleIds = inlineRecos.recos.map(reco => reco.styleId);
    trackEvent('TE_SEARCH_INLINE_RECOS_VIEW', `styles:${styleIds}:searchTerm:${searchTerm}`);
    const recommendationImpression = [{
      numberOfRecommendations: styleIds.length,
      recommendationType: 'PRODUCT_RECOMMENDATION',
      recommendationSource: 'EP13N',
      widgetType: 'SIMILAR_PRODUCT_WIDGET'
    }];
    track(() => ([ evRecommendationImpressionWrapper, { recommendationImpression } ]));
  }, [inlineRecos, searchTerm]);

  return !!recos?.length && (
    <aside className={css.container} data-reco-count={recos.length}>
      {title && <h2>{title}</h2>}
      <div className={css.recos}>
        {recos.map((reco, index) => {
          if (index < 4) {
            const { styleId, productId, link } = reco;
            return (
              <ProductCard
                {...reco}
                hearts={heartsInfo}
                msaImageParams={msaImageParams}
                key={styleId + productId}
                className={css.productCardOverride}
                imageNoBackground={true}
                productUrl={link}
                onClick={() => handleInlineRecoClick({ index, styleId, productId })}
              />
            );
          }
          return null;
        })}
      </div>
    </aside>
  );
};

export default withErrorBoundary('SearchInlineRecosNpc', SearchInlineRecosNpc);
